import { DataGrid } from "devextreme-react";
import React, { useMemo } from "react";
import { getPropsDataGridColSpan, getPropsDataGrid, getPropsDataGridEditing, getPropsDataGridPopup } from "../../../../../utils/default-props";
import { Column, Editing, FormItem, Popup, RequiredRule } from "devextreme-react/data-grid";
import { useDataSource } from "../../../../../contexts/dataSource";
import { useAuth } from "../../../../../contexts/auth";
import { getDataGridCustomToolbar } from "../../../../../components/default-components/data-grid-custom-toolbar";


function PolicyCompanyInfo() {

    const { user } = useAuth()
    const { dataSourceHR } = useDataSource()

    const dataSource = useMemo(() => dataSourceHR({
        loadUrl: "/api/PolicyCompanyInfo",
        insertUrl: "/api/PolicyCompanyInfo/FormData"
    }), [user])

    return (
        <React.Fragment>
            <div className={'content-block'}>
                <div className={'dx-card responsive-paddings'}>                    
                    <DataGrid
                        {...getPropsDataGrid}
                        dataSource={dataSource}
                    >
                        <Editing {...getPropsDataGridEditing}>
                            <Popup {...getPropsDataGridPopup} title="Sigorta Bilgisi" />
                        </Editing>

                        {getDataGridCustomToolbar("Sigorta Şirketleri")}

                        <Column dataField="name" caption="Sigorta Şirketi Adı">
                            <FormItem {...getPropsDataGridColSpan} />
                            <RequiredRule />
                        </Column>
                        <Column dataField="email" caption="E-Mail">
                            <FormItem {...getPropsDataGridColSpan} />
                            <RequiredRule />
                        </Column>
                        <Column dataField="phoneNumber" caption="Telefon Numarası">
                            <FormItem {...getPropsDataGridColSpan} />
                            <RequiredRule />                            
                        </Column>
                    </DataGrid>
                </div>
            </div>
        </React.Fragment>
    )
}

export default PolicyCompanyInfo